import React from 'react';
import { Menu, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import { notificationsConfig as config } from '../../../shared/constants';
import { useNotificationModeDispatch, useNotificationModeState } from '../lib';
import styles from './index.module.scss';

const renderMenuItem = ({ key, title, component, color }) => (
  <Menu.Item className={styles.item} key={key}>
    <Tooltip title={title}>
      <Icon component={component} style={{ color }} />
    </Tooltip>
  </Menu.Item>
);
const Navigation = ({ modes, className }) => {
  const mode = useNotificationModeState();
  const changeMode = useNotificationModeDispatch();

  if (!modes) {
    return null;
  }

  return (
    <Menu
      selectedKeys={[mode]}
      onClick={({ key }) => changeMode(key)}
      mode="horizontal"
      className={cn(styles.root, className)}
      getPopupContainer={(trigger) => trigger.parentNode}
    >
      {modes.length >= 2 &&
        renderMenuItem({
          key: config.all.name,
          title: config.all.tooltip,
          component: config.all.icon,
          color: 'currentColor',
        })}

      {modes.map((mode) =>
        renderMenuItem({
          key: mode,
          title: config[mode].tooltip,
          component: config[mode].icon,
          color: 'transparent',
        })
      )}
    </Menu>
  );
};

export default Navigation;
